import React from 'react';
import { clsx } from 'clsx';

import { useNotifications } from '@store/notifications';

import css from './styles.module.css';

const NotificationList: React.FC = () => {
  const { notifications, removeNotification } = useNotifications();

  return (
    <div className={css.notificationsContainer}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={clsx(css.notification, css[notification.type])}
          onClick={() => removeNotification(notification.id)}
        >
          {notification.message}
        </div>
      ))}
    </div>
  );
};

export default NotificationList;
